(function () {
	const WIDE = 1024;

	function init() {
		const nav = document.querySelector('nav.main-nav');
		const overlay = document.querySelector('.nav-overlay');
		const panel = document.querySelector('.nav-panel');
		const toggle = document.querySelector('.nav-toggle');
		if (!nav) return;

		const items = nav.querySelectorAll(':scope > ul > li.has-children');
		const hoverNone = window.matchMedia('(hover: none)');
		const wideMq = window.matchMedia('(min-width: ' + WIDE + 'px)');

		function setOpen(item, open) {
			item.classList.toggle('open', open);
			const trigger = item.querySelector(':scope > a');
			if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
		}

		function closeAll(except) {
			items.forEach(function (item) {
				if (item !== except) setOpen(item, false);
			});
		}

		function isDrawer() {
			return !wideMq.matches;
		}

		function focusables() {
			const list = [];
			if (toggle) list.push(toggle);
			if (overlay) {
				overlay.querySelectorAll('a, button').forEach(function (el) {
					list.push(el);
				});
			}
			return list;
		}

		function setDrawer(open) {
			if (!overlay || !toggle) return;
			document.body.classList.toggle('is-nav-open', open);
			document.documentElement.style.overflow = open ? 'hidden' : '';
			overlay.classList.toggle('is-open', open);
			toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
			toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
			document.body.style.overflow = open ? 'hidden' : '';

			if (isDrawer()) {
				overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
				if (open) overlay.removeAttribute('inert');
				else overlay.setAttribute('inert', '');
			} else {
				overlay.removeAttribute('aria-hidden');
				overlay.removeAttribute('inert');
			}

			if (!open) closeAll();
			if (!open && isDrawer()) toggle.focus();
		}

		items.forEach(function (item) {
			const trigger = item.querySelector(':scope > a');
			if (!trigger) return;

			trigger.setAttribute('aria-haspopup', 'true');
			trigger.setAttribute('aria-expanded', 'false');

			// Parent items are href="#" (no overview page). Always prevent
			// the jump-to-top; hover still opens the menu on pointer devices,
			// and a tap toggles it on touch / in the drawer.
			trigger.addEventListener('click', function (e) {
				e.preventDefault();
				if (!hoverNone.matches && !isDrawer()) return;
				const isOpen = item.classList.contains('open');
				closeAll(item);
				setOpen(item, !isOpen);
			});
		});

		if (toggle && overlay) {
			toggle.addEventListener('click', function () {
				setDrawer(!overlay.classList.contains('is-open'));
			});

			overlay.addEventListener('click', function (e) {
				if (e.target === overlay) setDrawer(false);
			});

			if (panel) {
				panel.addEventListener('click', function (e) {
					const link = e.target.closest('a');
					if (!link) return;
					if (link.getAttribute('href') === '#') return;
					if (isDrawer()) setDrawer(false);
				});
			}
		}

		document.addEventListener('click', function (e) {
			if (isDrawer()) return;
			if (!nav.contains(e.target)) closeAll();
		});

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape') {
				if (overlay && overlay.classList.contains('is-open')) {
					setDrawer(false);
					return;
				}
				closeAll();
			}

			if (e.key !== 'Tab' || !overlay || !overlay.classList.contains('is-open')) return;
			const els = focusables();
			if (els.length < 2) return;
			const first = els[0];
			const last = els[els.length - 1];
			if (e.shiftKey && document.activeElement === first) {
				e.preventDefault();
				last.focus();
			} else if (!e.shiftKey && document.activeElement === last) {
				e.preventDefault();
				first.focus();
			}
		});

		function onWideChange() {
			if (wideMq.matches) {
				setDrawer(false);
				if (overlay) {
					overlay.removeAttribute('aria-hidden');
					overlay.removeAttribute('inert');
				}
			} else if (overlay) {
				overlay.setAttribute('aria-hidden', 'true');
				overlay.setAttribute('inert', '');
			}
		}
		if (wideMq.addEventListener) {
			wideMq.addEventListener('change', onWideChange);
		} else {
			wideMq.addListener(onWideChange);
		}
		onWideChange();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
